import { ICON__copy_regular } from '@/assets/icons_fa';
import { HOOK_IMAGE__copy_to_clipboard } from '@/hooks/image/HOOK_IMAGE__copy_to_clipboard';
import { CONTEXT_MENU_ITEM__field_base } from '@/pages/page_generation/sidebar/_base/context_menu/_base/CONTEXT_MENU_ITEM__field_base';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

interface PROPS {
  image_asset: DTO__image_asset;
}

export function CONTEXT_MENU_ITEM__image__copy_to_clipboard({ image_asset }: PROPS) {
  /*
   *
   */
  const { copy_to_clipboard } = HOOK_IMAGE__copy_to_clipboard();

  /*
   *
   */

  async function onClick(): Promise<void> {
    copy_to_clipboard(image_asset);
  }

  /*
   *
   */

  if (image_asset.is_stub()) return null;
  if (image_asset.is_single_color) return null;

  return <CONTEXT_MENU_ITEM__field_base Icon={ICON__copy_regular} text={'Copy'} on_click={onClick} />;
}
